import { Navigate } from "react-router-dom";
import { useAuth } from "../../services/useAuth";

function PrivateRoute({ children ,loginStatus}) {
    const auth = useAuth(loginStatus)
    return auth ? children : <Navigate to="/admin" />;
  }
  export default PrivateRoute;